import { useEffect } from "react";
import {
  useGetProfilsBesse,
  usePostUtilisateur,
} from "../../../hooks/Utilisateurs";
import { Utilisateur } from "../../../services/Api/swagger";
import { Selectors as UtilisateursSelectors } from "../../../redux/Utilisateurs";
import Types from "Types";
import { useSelector } from "react-redux";

export const useAjouterUtilisateurBesse = () => {
  const utilisateurConnecte = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getUtilisateurConnecte(state)
  );

  const { mutate: mutateProfilBesse, data: profilsBesse } =
    useGetProfilsBesse();

  useEffect(() => {
    mutateProfilBesse("AGREMENT");
  }, []);

  const {
    mutate: mutateAddUtilisateur,
    isLoading: utilisateurFetching,
    error: utilisateurError,
    reset: resetPostUtilisateur,
  } = usePostUtilisateur();
  const ajouterUtilisateur = (param: Utilisateur) => {
    mutateAddUtilisateur(param);
  };

  return {
    profilsBesse,
    ajouterUtilisateur,
    utilisateurFetching,
    utilisateurError,
    resetPostUtilisateur,
    utilisateurConnecte,
  };
};
